import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createHocName from '../services/create-hoc-name';

const NAME = 'WithPermissions';

/*
Which permissions checker should I use?

* can - use when you only care about if user can do action or not - using this carries a message
  that action is visible only when user can actually do it.
* canSee - use it when you want to show that user could do an action, even
  if he currently can't. For example - like a post as logged in, but private member.
  Using this should be accompanied by decorating for user to login or become a public member.
* canRender - use it everywhere where you render UI based on permissions. It checks
  both can and canSee.*/

const createPermissionsChecker = (permissions, isSee) => (permission, resource, obj) => {
  return isSee ?
    permissions.canSee(permissions.resourcify(obj, resource), permission) :
    permissions.can(permissions.resourcify(obj, resource), permission);
};

const createPermissionsRenderHelper = (canSeeChecker, canChecker) => (permission, resource, obj, render) => {
  const renderFunc = render ? render : obj;

  const can = canChecker(permission, resource, obj);
  const canSee = canSeeChecker(permission, resource, obj);
  return can || canSee ? renderFunc(can, canSee) : null;
};

export default function withPermissions(WrappedComponent) {
  class WithPermissions extends Component {
    static displayName = createHocName(NAME, WrappedComponent);

    render() {
      const canSeePermissionsHelper = createPermissionsChecker(this.context.permissions, true);
      const canPermissionsHelper = createPermissionsChecker(this.context.permissions, false);
      const permissionsRenderHelper = createPermissionsRenderHelper(canSeePermissionsHelper, canPermissionsHelper);
      return (
        <WrappedComponent
          permissions={this.context.permissions}
          can={canPermissionsHelper}
          canSee={canSeePermissionsHelper}
          canRender={permissionsRenderHelper}
          {...this.props}
        />
      );
    }
  }

  WithPermissions.contextTypes = {
    permissions: PropTypes.object.isRequired,
  };

  hoistNonReactStatics(WithPermissions, WrappedComponent);

  return WithPermissions;
}



// WEBPACK FOOTER //
// ./app/hoc/with-permissions.js